// apps/web/src/layouts/components/SidebarVehicleQueueBadge.tsx
//
// Badge da fila de classificação FIPE (Produtos e preços > Catálogo de veículos):
// modelos importados sem subgrupo aguardando o operador. O número vem de
// `useSidebarBadgeCounts()`, montado uma vez no topo da sidebar admin.
// Contrato: docs/contracts/ESCR-fipe-import-classificacao.md.

import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

export interface SidebarVehicleQueueBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarVehicleQueueBadge({ count, variant }: SidebarVehicleQueueBadgeProps) {
  const { t } = useTranslation('admin_pricing');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-vehicle-queue-badge"
      label={t('vehicle_queue.badge_aria', { count })}
    />
  );
}
